import { PlanogramResponse } from "@/shared/api";
import { useViewSettings } from "@/view-settings";
import { PlanogramMesh } from "@/virtual-store/planogram/gondola-mesh";
import { useSelector } from "@legendapp/state/react";

export function Gondolas({ planogram }: { planogram: PlanogramResponse }) {
  const viewSettings = useViewSettings();
  const isVisible = useSelector(() => viewSettings.showGondolas.get());

  if (!isVisible) return null;

  return (
    <>
      {planogram?.result.gondolas.map((gondola) => (
        <PlanogramMesh
          label={gondola.name}
          key={gondola.id}
          vertices={
            gondola.vertices
              ?.map((vertex) => [vertex[0], vertex[2], -vertex[1]])
              ?.flatMap((vertices) => vertices) || []
          }
          faces={gondola.faces?.flatMap((face) => face) || []}
        />
      ))}
    </>
  );
}
